import { err, ok, Result } from 'neverthrow'
import { FailedToParseJsonError } from '../errors'

export const stringifyError = (error: unknown) => {
  if (error instanceof Error) {
    return JSON.stringify({
      name: error.name,
      message: error.message,
      stack: error.stack,
    })
  }
  return JSON.stringify(error)
}

export const parseJsonSafe = (
  str: string
): Result<unknown, FailedToParseJsonError> => {
  try {
    return ok(JSON.parse(str))
  } catch (_) {
    return err(new FailedToParseJsonError())
  }
}
